import { Button, Checkbox, FormControlLabel, FormGroup, Grid, Link, TextField } from '@mui/material'
import React, {useState, useEffect} from 'react'
import ImageComponents from '../../../../Shared/ImageComponents'
import CardValidator from '../../Components/cardValidator';
import MasterCardRupayForm from '../../Components/mastercardRupay';
import CustomizedDialogs from '../../../../Shared/CustomDialogs'
import Pos from '../POS/Pos';
import VisaMasterInfo from '../ChildComponents/VisaMasterInfo';
import Loader from '../../Components/loader';




function CreditCardSI({secret , cardDownBanks, displayMode, displayModeCheck}) {
    const [showVisaNetwork, setVisaNetwork] = useState(false);
    const [expiryMonthYear, setExpiryMonthYear] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expity, setExpiry] = useState('');
    const [cvv, setCvv] = useState('');
    const [name , setName] = useState('');
    const [cardNumberError, setCardNumberError] = useState('');
    const [cardCVVError, setCardCVVError] = useState('');
    const [cardExpiryError, setCardExpiryError] = useState('');
    const [showCardNameError , setshowCardNameError] = useState(false);
    const [cardNameError, setCardNameError] = useState('As mentioned on your Credit Card');
    const [txnurl , settxnurl ] = useState('');
    const [pgpayload , setpgpayload] = useState('');
    const [showLoader, setshowLoader] = useState(false);
    const [formHtml, setFormHtml] = useState('');
    const [showForm, setShowForm] = useState(0);
    const [rupayMap , setRupayMap] = useState('');
    const [isChecked, setIsChecked] = useState(true);
    const [isSIEligible , setIsSIEligible] =  useState(true);   
    const [NBerror, setNBerror] = useState(false);
    let form;
    let data;
    const validator = new CardValidator();
    const queryParameters = new URLSearchParams(window.location.search);
    const error = queryParameters.get("error");
    if(error==="1"){
     cardDownBanks ='HDFC Bank, ICICI Bank';
    }

    
    const getCardNetwork = (cardNumber) => {
       const newCardNumber = cardNumber.replace(/\s+/g, ''); 
       if(newCardNumber.length>5){
        const bin = newCardNumber.substring(0, 6);
        const visaPattern = /^4/;
         const mastercardPattern = /^(5[1-5][0-9]{4}|222[1-9][0-9]|22[3-9][0-9]{2}|2[3-6][0-9]{3}|27[01][0-9]{2}|2720[0-9])/;
        const amexPattern = /^3[47]/;
        const discoverPattern = /^6(?:011|5[0-9]{2})/;
        const rupayPattern = /^(508[5-9][0-9]|6069[8-9][5-9]|60698[5-9]|6069[9][0-9]|607[0-9]{3}|6080[0-9]{2}|6521[5-9][0-9]|652[2-9][0-9]{2}|6530[0-9]{2}|6531[0-4][0-9])/;
        const dinersPattern = /^3(?:0[0-5]|[68][0-9])[0-9]/;
         if (mastercardPattern.test(bin)) {
            return 'mastercard';
        } else if (visaPattern.test(bin)) {
            return 'visa';
        } else if (amexPattern.test(bin)) {
            return 'amex';
        }else if (dinersPattern.test(bin)) {
           return 'diners';
        }
        else if (rupayPattern.test(bin)){
            return 'rupay';
        } 
         else if (discoverPattern.test(bin)) {
            return 'discover';
        } 
        else {
            return 'card';
        }
        }else{
        return 'card';
        }
    };
	

	 useEffect(() => {
	         setNBerror(false);
	         setIsSIEligible(true);
  if (expiryMonthYear.length === 5 && displayMode === 6) {
     
    const validateExpiry = async () => {
      let [mm, yy] = expiryMonthYear.split('-');
      const data1 = await validator.isValidExpirySI(mm, yy); 
      if (data1.msg === 'true') {
        setIsSIEligible(false);
        setNBerror(true);
      }
    };

    validateExpiry();
  }
}, [expiryMonthYear]);
		
	
	
  const handleCvvChange = (event) => {
    const inputValue = event.target.value;
     
    if (!isNaN(inputValue) && inputValue.length <= 4) {
       setCvv(inputValue);
       
    }
  };

const handleExpiryChange = (event) => {
    let value = event.target.value;
    value = value.replace(/\D/g, '');
    if (/^[2-9]/.test(value)) {
        value = '0' + value;
    }
    if (value.length >= 2 && value.indexOf('-') === -1) {
        value = value.slice(0, 2) + '-' + value.slice(2);
    }
    const parts = value.split('-');
    if (parts.length === 2 && parts[1].length > 2) {
        value = parts[0] + '-' + parts[1].slice(0, 2);
    }
    setExpiryMonthYear(value);
};

const handleNameClick = () => {

setCardNameError('As mentioned on your Credit Card');
setshowCardNameError(false);

};
const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked); // Get the checked value
    console.log("Checkbox is checked:", event.target.checked); // Log the checked value
};

const handleExpiryClick = () => {
        setNBerror(false);
      setCardExpiryError('');
     if (expiryMonthYear === 'MM-YY') {
     setExpiryMonthYear('');
    }
  };

    
  
    
	
  const handleCvvClick = () => {
     setCardCVVError('');
     if (cvv === '****') {
      setCvv('');
     
    }
  };
  const handleCardNumberChange = (event) => {
        const value = event.target.value;
        const sanitizedValue = value.replace(/\D/g, '').slice(0, 16);
        const formattedValue = sanitizedValue.replace(/(.{4})/g, '$1 ').trim();
    	 setCardNumber(formattedValue);	
       // setCardNumber(sanitizedValue);
    };

const handleNameChange = (event) => {
    let value = event.target.value;
    value = value.replace(/[^A-Za-z\s]/g, '');
    setName(value);
};

    const handleCardNumberClick = () => {
     setCardNumberError('');
        if(cardNumber === 'XXXX-XXXX-XXXX-XXXX'){
         setCardNumber('');
        }
        
    };
    const handleKeyDown = (event) => {
        // Allow backspace key
        if (event.key === 'Backspace') {
            setExpiryMonthYear((prevValue) => prevValue.slice(0, -1));
        }
    };
      const handlePayNow = async () => {
      
      const queryParameters = new URLSearchParams(window.location.search);
      const mode = "CC";
      let ccNo = cardNumber;
      ccNo = ccNo.replace(/\s+/g, '');
      let ccCardHolder = name;
      let ccCVV = cvv;
      let orderNo = queryParameters.get("orderNo");
      let [month, year] = expiryMonthYear.split('-');
      console.log("isChecked: "+isChecked);
      let isOptSi = isChecked ?'1':'0';


      let isValid = false;
      setCardCVVError('');
      setCardExpiryError('');
      setCardNameError('');
      setCardNumberError('');
      if(validator.isValidCardNumber(ccNo)){
         if(validator.isValidCardName(ccCardHolder)){
            const isCardDateValid = validator.isValidExpiry(month,year);
            if (isCardDateValid) {
                if (displayModeCheck != null && displayModeCheck && isChecked) {
                    if (!validator.isValidDebitMonthYearSetup(month, '20'+year)) {
                        setCardExpiryError("The card expires soon putting your auto-debit at risk. Please use another card.");
                    } else {
                        if(validator.isValidCVV(ccCVV)){
                            isValid = true;
                        }else{
                            setCardCVVError('Please enter a valid CVV');
                        }
                    }
                } else {
                    const data = await validator.isValidExpirySI(month, year);
                    if(data.msg === 'true' && isSIEligible && isChecked){
                        setCardExpiryError('The card expires soon putting your auto-debit at risk. Please use another card.');
                    }else{
                       if(validator.isValidCVV(ccCVV)){
                            isValid = true;
                        }else{
                            setCardCVVError('Please enter a valid CVV');
                        } 
                    }
                }
            }else{
                setCardExpiryError('Please enter a valid expiry');
            }
         }else{
          setshowCardNameError(true);
          setCardNameError('Please enter a valid card holder name');
         }
       }else{
        setCardNumberError('Please enter a valid card number');
     }
       year = '20'+year;
      if(!isSIEligible){
      isOptSi = 0;
      } 
       
      if(isValid){
      	setshowLoader(true);
        ccNo = encodeURIComponent(validator.encrypt(ccNo, secret).toString());
        ccCVV = encodeURIComponent(validator.encrypt(ccCVV, secret).toString());
        ccCardHolder = encodeURIComponent(validator.encrypt(ccCardHolder, secret).toString());
        month = encodeURIComponent(validator.encrypt(month, secret).toString());
        year = encodeURIComponent(validator.encrypt(year, secret).toString());
        console.log("isOptSi"+isOptSi);
        isOptSi = encodeURIComponent(validator.encrypt(isOptSi, secret).toString());
     
      const cardData = {
            ccNo,
            ccCardHolder,
            ccExpiryMonth:month,
            ccExpiryYear:year,
            ccCVV,
            orderNo,
            isOptSi,
            mode : mode
        };
	
   
    try {
        const response = await fetch('/pay/securePayment/process/paymentui', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
             body: JSON.stringify(cardData)
        });
        data = await response.json();
        setshowLoader(false);
        console.log(data);
      if(data.as ===1){

        if(data.pgPayload.form){
            const formHtml = data.pgPayload.form;
            const tempContainer = document.createElement('div');
            tempContainer.innerHTML = formHtml;
      
            const formElement = tempContainer.querySelector('form');
            document.body.appendChild(formElement);
            formElement.submit();
            }

    
     
      
      else if(data.txnURL){
       settxnurl(data.txnURL);
       setpgpayload(data.pgPayload);
       await delay(1500);
       form = document.getElementById('testForm');
       form.submit();
      
      }
      
      
      } else if(data.as ===2){
       window.location.href = data.txnURL1;
      
      }else if(data.as===3){
        if(data.mastRupay){
        setShowForm(2);
        setRupayMap(data.mastRupay);
       }
        else{
          setFormHtml(data.form);
          setShowForm(data.showForm);
          await delay(1500);
        }
      
      }else if(data.error === 1){
        window.location.reload();      
        } 
    } catch (error) {
        console.error('Error:', error);
         window.location.reload();
    }
    
     
  }
  
  
};

const delay = millis => new Promise((resolve, reject) => {
  setTimeout(_ => resolve(), millis)
});
   
   
   
       
  return (
  
  <>
 
  {showLoader && <Loader show={true}/>}
    {pgpayload && (
    <form method="post" action={txnurl} id="testForm">
        {Object.keys(pgpayload).map((key, index) => (
            <input key={index} type="hidden" id={key} name={key} value={pgpayload[key]} />
        ))}
    </form>
)}
   
  {showForm === 1 && (
  <div style={{
    position: 'fixed', // Ensure this div covers the whole viewport
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white', // Blank background color
    display: 'flex',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    zIndex: 9999 // Ensure it's on top of other content
  }}>
    <div dangerouslySetInnerHTML={{ __html: formHtml }} />
  </div>
)}


 {showForm === 2 && (
  <div style={{
    position: 'fixed', // Ensure this div covers the whole viewport
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'white', // Blank background color
    //display: 'flex',
    width: '100%',
    height: '100%',
    justifyContent: 'center', // Center horizontally
    alignItems: 'center', // Center vertically
    zIndex: 9999 // Ensure it's on top of other content
  }}>
     <MasterCardRupayForm  mastRupay={rupayMap} />
  </div>
)}
   
  {cardDownBanks && cardDownBanks !== null && cardDownBanks.includes(',') && (
    <div className="generalMsgInfo">
        <strong>{cardDownBanks}</strong> are currently facing some technical issues.
    </div>
)}

{cardDownBanks && cardDownBanks !== null && !cardDownBanks.includes(',') && (
    <div className="generalMsgInfo">
        <strong>{cardDownBanks}</strong> is currently facing some technical issues.
    </div>
)}	
    <div className='card-details'>
      <div class="hidden md:block"><h5>
            Enter your Credit Card details
        </h5> </div>
 <div className='card-detail-form'>
            
            <Grid container spacing={3}>
                <Grid item md={12} xs={12}  className={`debit-card ${getCardNetwork(cardNumber)}`}>
                    <TextField
                       id="cardNumber"
                        label="Credit Card Number"
                          placeholder="XXXX-XXXX-XXXX-XXXX"
                        value={cardNumber}
                        fullWidth
                        error={!!cardNumberError}
                        helperText={cardNumberError}
                        style={{borderRadius:'8px'}}
                        onClick={handleCardNumberClick}
                        onChange={handleCardNumberChange}
                    />
                </Grid>
               <Grid item md={12} xs={12}>
                 <TextField
       	 id="name"
       	 label="Enter Your Name"
       	 fullWidth
       	 onChange={handleNameChange}
      	         onClick ={handleNameClick}
      	         error={showCardNameError}
                 helperText={cardNameError}
                 value={name}
  			  />
		</Grid>
                <Grid item md={6} xs={12}>
                    <TextField
                        id="expiry"
                        label="Expiry Month & Year"
                          placeholder="MM-YY"
                         error={!!cardExpiryError}
                            helperText={cardExpiryError}
                        value = {expiryMonthYear}
                        onClick ={handleExpiryClick}
                        onChange={handleExpiryChange}
                        onKeyDown={handleKeyDown}
                        fullWidth
                        
                    />
                </Grid>
                <Grid item md={6} xs={12}  className='cvv-box'>
                    <TextField
                        id="cvv"
                        label="CVV"
                        type="password"
                        value = {cvv}
                          placeholder="***"
                         error={!!cardCVVError}
                         helperText={cardCVVError}
                         onChange={handleCvvChange}
                        onClick={handleCvvClick}
                         fullWidth
                    />
                </Grid>
                <Grid item md={12} xs={12} className='autopay-check'>
                    <FormGroup>
                        <FormControlLabel control={<Checkbox id="autopayChecked" defaultChecked disabled={displayMode == 6} onChange={handleCheckboxChange} />} label="Set up Autopay on your Credit Card if applicable" />
                    </FormGroup>
                    <Button variant="outlined" size="large" className='pay-now-btn' onClick={handlePayNow}>
                        Pay now
                    </Button>
                     {NBerror && (
      <p style={{ color: 'red' }}>The payment will be processed however autopay will not be setup, as your card is expiring within 90 days.</p>
    )}
              
                </Grid>
             	
            </Grid>
        </div>
        {showVisaNetwork ? <CustomizedDialogs className="dialog-inner-box" open={showVisaNetwork} handleClose={() => setVisaNetwork(false)}>
        <VisaMasterInfo handleClose={() => setVisaNetwork(false)}/>
      </CustomizedDialogs> : null}
    </div>
    </>
  )
}

export default CreditCardSI
